export default __webpack_public_path__ + "static/media/DecorationA.5bc30d6c.png";